import { useContext } from 'react';
import CurrencyContext from 'contexts/Currency/CurrencyContext';

export default function useCurrency() {
    const { state } = useContext(CurrencyContext);
    return [state.currency];
}
